import React from "react";
import { FormattedMessage } from "react-intl";

type Props = {};

const DocumentGeneralVerificationGuidelines: React.FC<Props> = () => {
  return (
    <div className="document-verification-guidelines">
      <p>
        <FormattedMessage
          id="account-verification-guidelines-title"
          defaultMessage="In order to complete verification, please take care when uploading your image"
        />
      </p>
      <ul>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-image-flat-surface"
            defaultMessage="Image must be on a flat surface."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-image-unobscured"
            defaultMessage="There must not be anything obscuring the image (i.e., hands)."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-image-clear-details"
            defaultMessage="The image must be clear with all the details visible."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-image-no-blur-glare"
            defaultMessage="Images with blur or glare will not be accepted."
          />
        </li>
      </ul>
    </div>
  );
};

export default DocumentGeneralVerificationGuidelines;
